import React, { useContext, useEffect } from 'react';
import { Button, Segment, Grid, Divider, Header, Icon, Rail, Container, Popup, } from 'semantic-ui-react';
import MobileStore from '../../../app/stores/mobileStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import MobileTab from './MobileTab';
import MobileNotesFeed from './MobileNotesFeed';

interface DetailParams {
  id: string;
}

const MobileDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const mobileStore = useContext(MobileStore);
  const { project, loadProject, loadProjectNotes, loadTechnicians, loadProjectVendors, loadMobileAssignments,
    loadProjectDocuments, customerRegistry, loadingInitial, clearPage} = mobileStore;

  useEffect(() => {
    loadProject(match.params.id);
    loadProjectNotes(match.params.id);
    loadTechnicians().then(() => loadMobileAssignments(match.params.id));
    loadProjectVendors(match.params.id);
    loadProjectDocuments(match.params.id);
   // loadMobileAssignments(match.params.id);
    
    return () => {
      clearPage();
    };
  }, []);

  if (loadingInitial || !project) return <LoadingComponent content='Loading Project ...' /> 
  
  return (
    <Segment style={{marginRight: "22rem"}}>
      <Grid>
        <Grid.Column width={2} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Project Code:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Site Id:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Site Name:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Address:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Receive Date:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Require Date:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Remark:</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={6}>
          <span style={{ fontSize: 16 }}>{project.projectCode}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>
          <Link to={`/projectmanagement/sitevodafone?siteid=${project.siteId}`} style={{ color: "blue" }}>
            {project.siteId}</Link>
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {project.siteName}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.address}</span>
          <Popup
              content="Open in google map"
              trigger={
                  <a href={`https://maps.google.com/?q=${project.address}`} target="_Blank">
                    <Icon name='map marker alternate' size='large'/>
                  </a>
                      }
            />
          <br></br>
          <span style={{ fontSize: 16 }}>{project.receiveDate}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.requireDate}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.remark}</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={4} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Status:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Category:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Customer:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Work Type:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Actual RFQ Submit Date:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Expect Delivery Date:</span>
          <br></br>      
        </Grid.Column>
        <Grid.Column width={4}>
          <span style={{ fontSize: 16 }}><strong>{project.status}</strong></span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.category}</span>
          <br></br>
          <span style={{ fontSize: 16 }}><Link to={`/dailymanagement/customer/${project.customerId}`} style={{ color: "blue" }}>
            {customerRegistry.get(project.customerId).name}</Link></span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {project.workType}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {project.jobStartDate}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.estimatedCompletionDate}</span>
          <br></br>
          <Button
            onClick={() => history.push("/projectmanagement/mobile")}
            color="grey"
            floated="right"
            content="Cancel"
          />
          <Button
            as={Link}
            to={`/projectmanagement/mobile-edit/${project.id}`}
            color="blue"
            floated="right"
            content="Edit"
          />
        </Grid.Column>
      </Grid>
      <Divider horizontal >
      <Header as='h4'>
        <Icon name='arrow alternate circle down' />
        Details
      </Header>
    </Divider>
    <MobileTab />
    <Rail position='right' attached style={{width: "22rem"}}>
          <MobileNotesFeed/>
        </Rail>
    </Segment>
  );
};

export default observer(MobileDetails);
